<template>
  <div :key="page_key" class="page__flash_sale a-page">
    <div style="background-color:white; padding: 15px; border-radius: 4px; overflow: hidden">
      <el-row>
        <el-col :sm="12">
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"></shop-select>
        </el-col>
      </el-row>

      <div v-if="current_component === 'list'" style="margin-top: 40px">
        <el-tabs v-model="tab" @tab-click="m__get_campaigns">
          <el-tab-pane label="Chương trình có thể tham gia" name="1">
          </el-tab-pane>
          <el-tab-pane label="Thư mời" name="4">
          </el-tab-pane>
          <el-tab-pane label="Chương trình được đề cử" name="2">
          </el-tab-pane>
          <!--          <el-tab-pane label="File Flash Sale đã lưu" name="5"
                                 :disabled="!shopee_shop.selected">
                    </el-tab-pane>-->
        </el-tabs>

        <div v-if="tab !== '5'">
          <div v-if="campaign_list.length" style="margin-top: 20px">
            <div v-for="(campaign) in campaign_list"
                 style="padding: 20px 0; border-bottom: 1px solid #e8e8e8; display: flex;">
              <div
                style="width: 330px; height: 120px; padding: 20px; background-image: url('https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/cmt-sc/image/fs-bg.5a7dd1d.png'); background-size: cover;">
                <div style="display: flex; gap: 20px; align-items: center">
                  <div
                    style="background-color: #fff; color: orangered; font-weight: 600; font-size: 12px; padding: 2px">
                    <template
                      v-if="campaign.start_time * 1000 <= new Date().getTime() && campaign.end_time * 1000 >= new Date().getTime()">
                      {{ $t('base.ongoing').toUpperCase() }}
                    </template>
                    <template v-else-if="campaign.end_time * 1000 >= new Date().getTime()">
                      {{ $t('base.upcoming').toUpperCase() }}
                    </template>
                    <template v-else>
                      {{ $t('base.expired').toUpperCase() }}
                    </template>
                  </div>
                  <div style="padding: 2px;">
                    <i class="el-icon-date"
                       style="color: #fff !important; font-size: 13px !important; font-weight: 700 !important;"></i>
                    <span style="color: #fff !important; font-size: 13px !important; font-weight: 700 !important;">
                      {{ campaign.start_time * 1000 | moment('DD-MM') }}
                      ~
                      {{ campaign.end_time * 1000 | moment('DD-MM') }}
                    </span>
                  </div>
                </div>
                <div style="display: flex; gap: 30px; align-items: center; margin-top: 20px">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="101" height="20" viewBox="0 0 101 20" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M18.7223 0H12.9445L8.05565 9.77778L12.0556 11.1111L11.1668 20L19.6112 7.11111L15.6112 5.77778L18.7223 0ZM3.12727 16.4193H0V3.47573H7.82712V6.19116H3.12727V8.90659H7.02296V11.622H3.12727V16.4193ZM27.113 16.4193L26.3267 13.7038H22.3416L21.5732 16.4193H18.3566L22.699 3.47573H25.9871L30.3296 16.4193H27.113ZM24.361 6.4265H24.3252C24.3252 6.4265 24.0393 7.83852 23.807 8.65315L23.0743 11.1694H25.594L24.8792 8.65315C24.6469 7.83852 24.361 6.4265 24.361 6.4265ZM35.2776 16.6365C32.2754 16.6365 30.6135 14.79 30.6135 14.79L32.2576 12.3823C32.2576 12.3823 33.7051 13.7219 35.3134 13.7219C35.9567 13.7219 36.6536 13.4685 36.6536 12.6901C36.6536 12.1003 35.8081 11.7445 34.7654 11.3057C33.0877 10.5998 30.8994 9.67904 30.8994 7.22302C30.8994 4.83345 32.883 3.2585 35.4206 3.2585C38.1726 3.2585 39.5307 4.72483 39.5307 4.72483L38.2083 7.31354C38.2083 7.31354 36.9217 6.17306 35.3848 6.17306C34.7415 6.17306 34.0267 6.4627 34.0267 7.18682C34.0267 7.81718 34.8881 8.16029 35.9443 8.58102C37.6179 9.24773 39.7809 10.1093 39.7809 12.6177C39.7809 14.7719 38.1547 16.6365 35.2776 16.6365ZM41.7268 16.4193H44.854V11.3505H49.5003V16.4193H52.6275V3.47573H49.5003V8.65315H44.854V3.47573H41.7268V16.4193ZM64.1431 16.6923C61.1452 16.6923 59.4856 14.8458 59.4856 14.8458L61.1273 12.4381C61.1273 12.4381 62.5728 13.7777 64.1788 13.7777C64.8212 13.7777 65.5171 13.5243 65.5171 12.7459C65.5171 12.156 64.6728 11.8003 63.6315 11.3615C61.9563 10.6556 59.7712 9.73483 59.7712 7.27881C59.7712 4.88924 61.7519 3.31429 64.2858 3.31429C67.0339 3.31429 68.3901 4.78062 68.3901 4.78062L67.0696 7.36933C67.0696 7.36933 65.7848 6.22885 64.2501 6.22885C63.6077 6.22885 62.894 6.51849 62.894 7.24261C62.894 7.87297 63.7541 8.21608 64.8088 8.63681C66.4801 9.30352 68.6399 10.1651 68.6399 12.6735C68.6399 14.8277 67.0161 16.6923 64.1431 16.6923ZM77.0481 13.7595L77.8344 16.4749H81.051L78.8798 10.0031L76.7086 3.53134H73.4205L71.2493 10.0031L69.078 16.4749H72.2947L73.0631 13.7595H77.0481ZM75.0467 6.48211H75.0824C75.0824 6.48211 75.3683 7.89413 75.6006 8.70876L76.3154 11.2251H73.7958L74.5284 8.70876C74.7607 7.89413 75.0467 6.48211 75.0467 6.48211ZM82.3438 3.55759V16.4033H90.7552V13.8025H85.3751V3.55759H82.3438ZM100.22 3.60335V6.11228H94.7876V8.74164L99.1507 8.76171V11.2706H94.8283V13.9H100.503V16.4491H91.9999V3.60335H100.22Z"
                            fill="#FFFFFF"></path>
                    </svg>
                  </div>
                  <div style="color: #fff; font-weight: bold; font-size: 18px">
                    Campaign
                  </div>
                </div>
              </div>
              <div style="flex: auto; padding: 0 20px; position: relative">
                <div style="display: flex; gap: 10px; align-items: center">
                  <el-tag
                    v-if="campaign.start_time * 1000 <= new Date().getTime() && campaign.end_time * 1000 >= new Date().getTime()"
                    type="success">
                    {{ $t('base.ongoing') }}
                  </el-tag>
                  <el-tag v-else-if="campaign.end_time * 1000 >= new Date().getTime()" type="danger">
                    {{ $t('base.upcoming') }}
                  </el-tag>
                  <el-tag v-else type="info">
                    {{ $t('base.expired') }}
                  </el-tag>
                  <span style="font-size: 16px; font-weight: bold">{{ campaign.description }}</span>
                </div>
                <div style="margin-top: 10px; font-size: 13px; line-height: 22px">
                  Thời gian chương trình:
                  {{ campaign.start_time * 1000 | moment('HH:mm:ss DD-MM-YYYY') }}
                  đến
                  {{ campaign.end_time * 1000 | moment('HH:mm:ss DD-MM-YYYY') }}

                  <br>
                  <template v-if="campaign.nomination_timeslot.earliest_nomination_start_time > dayjs().unix()">
                    Thời gian đăng ký sớm nhất bắt đầu trong
                    <strong style="color: orangered">
                      {{
                        m__get_time_diff(dayjs().unix(), campaign.nomination_timeslot.earliest_nomination_start_time)
                      }}
                    </strong>
                  </template>
                  <template v-else-if="campaign.nomination_timeslot.latest_nomination_end_time >= dayjs().unix()">
                    Thời gian đăng ký từ kết thúc đến
                    <strong style="color: orangered">
                      {{ m__get_time_diff(dayjs().unix(), campaign.nomination_timeslot.latest_nomination_end_time) }}
                    </strong>
                  </template>
                  <template v-else>
                    Thời gian đăng ký đã kết thúc
                  </template>
                </div>
                <div
                  style="position: absolute; left: 20px; bottom: 0; width: calc(100% - 40px); height: 30px; font-size: 13px; display: flex; align-items: end">
                  Chương trình có thể đăng ký: {{ campaign.session_statistics.available_session_num }}
                  &nbsp;&nbsp;
                  Chờ xác nhận: {{ campaign.session_statistics.pending_session_num }}
                  &nbsp;&nbsp;
                  Đã đăng ký: {{ campaign.session_statistics.nominated_session_num }}
                </div>
              </div>
              <div style="width: 150px; display: flex; align-items: center">
                <el-button type="primary" size="small" @click="m__show_get_session_dialog(campaign)"
                           style="width: 150px">
                  <template v-if="campaign.nomination_timeslot.earliest_nomination_start_time > dayjs().unix()">
                    Xem chi tiết
                  </template>
                  <template v-else-if="campaign.session_statistics.nominated_session_num">
                    Thay đổi hoặc thêm
                  </template>
                  <template v-else>
                    Đăng ký ngay
                  </template>
                </el-button>
              </div>
            </div>
          </div>
          <div v-else>
            <NoDataComponent></NoDataComponent>
          </div>
        </div>
      </div>

      <div v-if="current_component === 'update'">
        <ShopeeFlashSaleUpdateComponent :seller="seller"
                                        :shop="shop"
                                        :shop_id="shopee_shop.selected"
                                        :shopee_id="selected_shop.shop_id"
                                        :shops="shopee_shop.list"
                                        :loading_get_products="loading.get_product"
                                        :product_list="product_list"
                                        :item_stock_price_infos="item_stock_price_infos"
                                        :model_list="model_list"
                                        :campaigns="[selected_campaign]"
                                        :selected_product_ids="[]"
                                        :flash_sale_files="flash_sale_files"
                                        @m__back_to_list="m__back_to_list"></ShopeeFlashSaleUpdateComponent>
      </div>
    </div>

    <el-dialog width="1300px" :close-on-click-modal="false" :visible.sync="show_dialog.get_session"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p><strong style="font-size: 18px">{{ selected_campaign && selected_campaign.description }}</strong></p>
        <div v-if="selected_campaign" style="display: flex; gap: 60px;">
          <div>
            <div style="font-size: 14px">Thời gian diễn ra</div>
            <div v-if="selected_campaign" style="font-size: 14px; margin-top: 10px">
              <!--              <pre>{{ selected_campaign }}</pre>-->
              {{ selected_campaign.start_time * 1000 | moment('HH:mm DD/MM/YYYY') }}
              -
              {{ selected_campaign.end_time * 1000 | moment('HH:mm DD/MM/YYYY') }}
            </div>
          </div>
        </div>

        <br>
        <br>
        <br>

        <p><strong style="font-size: 18px">Danh sách Khung giờ</strong></p>

        <!--        <pre>{{ session_list}}</pre>-->

        <div v-loading="loading.get_session">
          <div v-for="(campaign) in session_list"
               style="padding: 20px 0; border-bottom: 1px solid #e8e8e8; display: flex;">
            <div
              style="width: 300px; min-width: 300px; height: 100px; padding: 20px; background-image: url('https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/mmf_portal_seller_root_dir/static/modules/cmt-sc/image/fs-bg.5a7dd1d.png'); background-size: cover;">
              <div style="display: flex; gap: 20px; align-items: center">
                <div
                  style="background-color: #fff; color: orangered; font-weight: 600; font-size: 12px; padding: 2px">
                  <template v-if="campaign.nomination_start_time > dayjs().unix()">
                    Đăng ký sắp mở
                  </template>
                  <template
                    v-else-if="campaign.nomination_start_time * 1000 <= new Date().getTime() && campaign.nomination_end_time * 1000 >= new Date().getTime()">
                    ĐANG DIỄN RA
                  </template>
                  <template v-else-if="campaign.nomination_end_time * 1000 >= new Date().getTime()">
                    SẮP DIỄN RA
                  </template>
                  <template v-else>ĐÃ KẾT THÚC
                  </template>
                </div>
                <div style="padding: 2px;">
                  <i class="el-icon-date"
                     style="color: #fff !important; font-size: 13px !important; font-weight: 700 !important;"></i>
                  <span style="color: #fff !important; font-size: 13px !important; font-weight: 700 !important;">
                      {{ campaign.session_start_time * 1000 | moment('DD-MM') }}
                      ~
                      {{ campaign.session_end_time * 1000 | moment('DD-MM') }}
                    </span>
                </div>
              </div>
              <div style="display: flex; gap: 30px; align-items: center; margin-top: 20px">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="101" height="20" viewBox="0 0 101 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M18.7223 0H12.9445L8.05565 9.77778L12.0556 11.1111L11.1668 20L19.6112 7.11111L15.6112 5.77778L18.7223 0ZM3.12727 16.4193H0V3.47573H7.82712V6.19116H3.12727V8.90659H7.02296V11.622H3.12727V16.4193ZM27.113 16.4193L26.3267 13.7038H22.3416L21.5732 16.4193H18.3566L22.699 3.47573H25.9871L30.3296 16.4193H27.113ZM24.361 6.4265H24.3252C24.3252 6.4265 24.0393 7.83852 23.807 8.65315L23.0743 11.1694H25.594L24.8792 8.65315C24.6469 7.83852 24.361 6.4265 24.361 6.4265ZM35.2776 16.6365C32.2754 16.6365 30.6135 14.79 30.6135 14.79L32.2576 12.3823C32.2576 12.3823 33.7051 13.7219 35.3134 13.7219C35.9567 13.7219 36.6536 13.4685 36.6536 12.6901C36.6536 12.1003 35.8081 11.7445 34.7654 11.3057C33.0877 10.5998 30.8994 9.67904 30.8994 7.22302C30.8994 4.83345 32.883 3.2585 35.4206 3.2585C38.1726 3.2585 39.5307 4.72483 39.5307 4.72483L38.2083 7.31354C38.2083 7.31354 36.9217 6.17306 35.3848 6.17306C34.7415 6.17306 34.0267 6.4627 34.0267 7.18682C34.0267 7.81718 34.8881 8.16029 35.9443 8.58102C37.6179 9.24773 39.7809 10.1093 39.7809 12.6177C39.7809 14.7719 38.1547 16.6365 35.2776 16.6365ZM41.7268 16.4193H44.854V11.3505H49.5003V16.4193H52.6275V3.47573H49.5003V8.65315H44.854V3.47573H41.7268V16.4193ZM64.1431 16.6923C61.1452 16.6923 59.4856 14.8458 59.4856 14.8458L61.1273 12.4381C61.1273 12.4381 62.5728 13.7777 64.1788 13.7777C64.8212 13.7777 65.5171 13.5243 65.5171 12.7459C65.5171 12.156 64.6728 11.8003 63.6315 11.3615C61.9563 10.6556 59.7712 9.73483 59.7712 7.27881C59.7712 4.88924 61.7519 3.31429 64.2858 3.31429C67.0339 3.31429 68.3901 4.78062 68.3901 4.78062L67.0696 7.36933C67.0696 7.36933 65.7848 6.22885 64.2501 6.22885C63.6077 6.22885 62.894 6.51849 62.894 7.24261C62.894 7.87297 63.7541 8.21608 64.8088 8.63681C66.4801 9.30352 68.6399 10.1651 68.6399 12.6735C68.6399 14.8277 67.0161 16.6923 64.1431 16.6923ZM77.0481 13.7595L77.8344 16.4749H81.051L78.8798 10.0031L76.7086 3.53134H73.4205L71.2493 10.0031L69.078 16.4749H72.2947L73.0631 13.7595H77.0481ZM75.0467 6.48211H75.0824C75.0824 6.48211 75.3683 7.89413 75.6006 8.70876L76.3154 11.2251H73.7958L74.5284 8.70876C74.7607 7.89413 75.0467 6.48211 75.0467 6.48211ZM82.3438 3.55759V16.4033H90.7552V13.8025H85.3751V3.55759H82.3438ZM100.22 3.60335V6.11228H94.7876V8.74164L99.1507 8.76171V11.2706H94.8283V13.9H100.503V16.4491H91.9999V3.60335H100.22Z"
                          fill="#FFFFFF"></path>
                  </svg>
                </div>
                <div style="color: #fff; font-weight: bold; font-size: 18px">
                  Campaign
                </div>
              </div>
            </div>
            <div style="flex: auto; padding: 0 20px; position: relative">
              <div style="display: flex; gap: 10px; align-items: center">
                <el-tag
                  v-if="campaign.session_start_time * 1000 <= new Date().getTime() && campaign.session_end_time * 1000 >= new Date().getTime()"
                  type="success">
                  Đang diễn ra
                </el-tag>
                <el-tag v-else-if="campaign.session_end_time * 1000 >= new Date().getTime()" type="danger">Sắp diễn ra
                </el-tag>
                <el-tag v-else type="info">Đã kết thúc
                </el-tag>
                <span style="font-size: 16px; font-weight: bold">{{ campaign.description }}</span>
              </div>
              <div style="margin-top: 10px; font-size: 13px">
                Thời gian chương trình:
                {{ campaign.session_start_time * 1000 | moment('HH:mm:ss DD-MM-YYYY') }}
                đến
                {{ campaign.session_end_time * 1000 | moment('HH:mm:ss DD-MM-YYYY') }}
              </div>
              <div
                style="position: absolute; left: 20px; bottom: 0; width: calc(100% - 40px); height: 30px; font-size: 13px; display: flex; align-items: end">
                Đề cử: {{ campaign.statistics.nominated_count }} phân loại
                &nbsp;&nbsp;
                Đã được duyệt: {{ campaign.statistics.approved_count }} phân loại
              </div>
            </div>
            <div style="width: 150px; display: flex; align-items: center">
              <el-button type="primary" size="small" @click="m__update_shopee_flash_sale_product(campaign)">
                <template v-if="campaign.statistics.nominated_count">
                  Thay đổi hoặc thêm
                </template>
                <template v-else>
                  Đăng ký sản phẩm
                </template>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import store from '../../store'
import {flash_sale_advanced_list} from '../../addon/fixed_list'
import {chunk as _chunk, orderBy as _orderBy} from 'lodash'
import {check_channel, check_feature, show_expr_notification} from "../../addon/check_license";
import NoDataComponent from '../../components/no_data'
import ShopeeFlashSaleUpdateComponent from './update.vue'

export default {
  components: {
    NoDataComponent,
    ShopeeFlashSaleUpdateComponent
  },

  data() {
    return {
      page_key: '',

      current_component: 'list',
      tab: '1',
      shopee_shop: {
        loading: false,
        list: [],
        selected: ''
      },
      selected_shop: {},
      shop: null,
      seller: null,
      loading: {
        get_flash_sale: false,
        time_slot: false,
        confirm_create: false,
        get_products: false,
        select_shop: false,
        update_discount: false,
        update_auto: false,
        get_product: false,
        create_flash_sale_file: false,

        create_flash_sale_advanced_file: false,
        get_session: false
      },
      show_dialog: {
        create_flash_sale: false,
        flash_sale_files: false,
        select_shop: false,
        show_flash_sale_file_products: false,
        update_auto: false,
        create_flash_sale_file: false,
        create_flash_sale_filename: false,

        create_flash_sale_advanced_file: false,
        create_flash_sale_advanced_filename: false,

        get_session: false
      },

      campaign_list: [],

      product_list: [],
      item_stock_price_infos: [],
      model_list: {},
      product_selected_list: [],

      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        available: false
      },
      indeterminate: false,
      is_selected_all: false,

      flash_sale_files: [],
      input_keyword: '',
      filename: '',
      selected_shop_id: '',

      product_sort_option: {
        order: null,
        prop: null
      },

      selected_campaign: {},
      session_list: []
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_feature('flash_sale_advanced') || check_channel('shopee_marketing_fs') || flash_sale_advanced_list.includes(store.state.userInfo.username)) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()
    await this.m__get_flash_sale_files()
  },

  watch: {
    'shopee_shop.selected': function () {
      this.page_key = new Date().getTime()
      this.m__initial_view()
    }
  },

  methods: {
    m__get_time_diff(start_time, end_time) {
      const start = this.dayjs(start_time * 1000);
      const end = this.dayjs(end_time * 1000);

      const diff_in_ms = end.diff(start);
      const diff_duration = dayjs.duration(diff_in_ms);

      const days = Math.floor(diff_duration.asDays());
      const hours = Math.floor(diff_duration.asHours()) % 24;
      const minutes = diff_duration.minutes();

      let result = '';
      if (days > 0) {
        result += `${days} ngày `;
      }
      if (hours > 0) {
        result += `${hours} giờ `;
      }
      if (minutes > 0 || result === '') {
        result += `${minutes} phút`;
      }

      return result.trim();
    },

    async m__update_shopee_flash_sale_product(campaign) {
      this.selected_campaign = campaign
      this.current_component = 'update'
      this.show_dialog.get_session = false
    },

    async m__show_get_session_dialog(campaign) {
      this.loading.get_session = true
      this.show_dialog.get_session = true
      this.selected_campaign = campaign
      try {
        const data = {
          campaign_id: campaign.id,
          campaign_scene: 'CAMPAIGN_SCENE_FLASH_SALE',
          mechanic_label_ids: [],
          page_info: {
            limit: 100,
            offset: 0
          },
          recruiting_type: 2,
          show_available_only: false,
          sorting: 1,
          view_type: 0
        }

        const response = await this.seller.get_session_list_for_sc_v2(data)
        // console.log(response)

        this.session_list = _orderBy(response.data.list, ['session_start_time'], ['asc'])
      } catch (e) {
        console.error(e)
      }

      this.show_dialog.get_session = true
      this.loading.get_session = false
    },

    async m__get_shopee_shop() {
      this.shopee_shop.loading = true
      try {
        const resp = await this.$http.get(this.API.shopee_manager__get_shop + '?channel=shopee_marketing', this.cf())
        const resp_sub_account = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/get_shop', this.cf())
        this.shopee_shop.list = [...resp.body.data, ...resp_sub_account.body.data]

        const shop_default = this.shopee_shop.list.length === 1
          ? this.shopee_shop.list[0]
          : this.$route.query.shop_id ? this.shopee_shop.list.find(i => i.shop_id === this.$route.query.shop_id) : this.shopee_shop.list.find(i => !i.is_sub_account && i.extra_data && i.extra_data.default)
        if (shop_default) {
          this.shopee_shop.selected = shop_default._id
          this.ntf_s(`Chọn cửa hàng mặc định: ${shop_default.username}`)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.shopee_shop.loading = false
      }
    },

    async m__initial_view() {
      let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)
      if (!this.check_role(items[0], 'marketing', 'flash_sale')) {
        return
      }

      this.loading.get_flash_sale = true
      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            this.selected_shop = items[0]
            let item = items[0]
            this.shop = item
            this.seller = await this.init_seller(item)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              this.flash_sale_list = []
              return
            }

            await Promise.all([
              this.m__get_campaigns(),
              this.m__get_product(null, true)
            ])

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
        this.loading.get_flash_sale = false
      }
    },

    async m__get_product(seller = null, performance = false) {
      if (!seller || !seller.username) seller = this.seller

      try {
        this.loading.get_product = true
        this.product_selected_list = []
        this.product_list = []
        this.model_list = {}

        const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_marketing_products', {
          shop_id: this.shop.shop_id
        }, this.cf())
        console.log('cache_response', cache_response)

        const product_cache_list = cache_response && cache_response.body && cache_response.body.data && cache_response.body.data.length
          ? typeof cache_response.body.data === 'string' ? JSON.parse(cache_response.body.data) : cache_response.body.data
          : []

        if (product_cache_list.length > 100) {
          const chunk_list = _chunk(product_cache_list, 50)
          for (const chunk of chunk_list) {
            if (this.is_destroyed) return

            const product_detail_list = []
            const product_ids = chunk.map(i => i.itemid.toString())

            // todo: get cache data
            const products_by_graphql_cache_cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_products_by_graphql', {
              shop_id: this.shop.shop_id,
              product_ids: product_ids
            }, this.cf())
            if (products_by_graphql_cache_cache_response && products_by_graphql_cache_cache_response.body && products_by_graphql_cache_cache_response.body.data) {
              const data = typeof products_by_graphql_cache_cache_response === 'string'
                ? JSON.parse(products_by_graphql_cache_cache_response.body.data)
                : products_by_graphql_cache_cache_response.body.data
              product_detail_list.push(...data.map(i => JSON.parse(i.response)))
            }

            // todo: get missing cache data
            if (product_detail_list.length < chunk.length) {
              const founded_product_ids_set = new Set(product_detail_list.map(i => i.itemid.toString()))
              const missing_product_id = chunk.filter(i => !founded_product_ids_set.has(i.itemid.toString())).map(i => i.itemid.toString())
              const products_detail = await seller.get_product_by_graphql(missing_product_id)
              if (products_detail && products_detail.data && products_detail.data.products && products_detail.data.products.items) {
                product_detail_list.push(...products_detail.data.products.items)
              }
            }
            // console.log('product_detail_list', product_detail_list)

            for (const item of product_detail_list) {
              const product_model = {}
              product_model[+item.itemid] = item.modelList.map(i => {
                i.modelid = +i.modelid
                i.price = +i.originPrice
                i.stock = +i.normalStock
                i.checked = false
                i.enable = false
                i.discount_price = i.price
                i.discount_percent = 0
                i.quantity = i.stock
                i.message = ''
                i.error_message = ''
                return i
              })
              Object.assign(this.model_list, product_model)
            }

            for (const i of chunk) {
              i.selected = false
              i.checked = false
              i.limit = 0
              i.limit_value = 100
              i.enable = false
              i.error_message = ''
              i.revenue = i.price * i.sold
              i.add_to_cart_units = 0
              i.created = false
            }
            this.product_list.push(...chunk)
          }

          console.log('loaded products from cache')
        } else {
          let offset = 0, limit = 50
          let product_response = await seller.flash_sale_get_product(offset, limit)

          while (product_response.data.item_list && product_response.data.item_list.length) {
            if (this.is_destroyed) return

            const products_detail = await seller.get_product_by_graphql(product_response.data.item_list.map(i => i.itemid.toString()))
            for (const item of products_detail.data.products.items) {
              const product_model = {}
              product_model[+item.itemid] = item.modelList.map(i => {
                i.modelid = +i.modelid
                i.price = +i.originPrice
                i.stock = +i.normalStock
                i.checked = false
                i.enable = false
                i.discount_price = i.price
                i.discount_percent = 0
                i.quantity = i.stock
                i.message = ''
                i.error_message = ''
                return i
              })
              Object.assign(this.model_list, product_model)
            }

            for (const i of product_response.data.item_list) {
              i.selected = false
              i.checked = false
              i.limit = 0
              i.limit_value = 100
              i.enable = false
              i.error_message = ''
              i.revenue = i.price * i.sold
              i.add_to_cart_units = 0
              i.created = false
            }
            this.product_list.push(...product_response.data.item_list)

            offset += limit
            product_response = await seller.flash_sale_get_product(offset, limit)
          }
        }

        if (performance) {
          this.is_destroyed = true
          this.is_destroyed = false
          this.m__get_product_performance(seller)
            .catch(console.error)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_product = false
      }
    },

    async m__get_product_performance(seller) {
      try {
        let page = 1, page_size = 20
        const start_time = this.dayjs().subtract(30, 'days').startOf('d').unix()
        const end_time = this.dayjs().startOf('d').unix()
        let product_performance_resp = await seller.get_product_performance_v3(page, page_size, start_time, end_time, 'past30days')

        const performance_list = []
        while (!this.is_destroyed && this.seller && seller && this.seller.username === seller.username &&
        product_performance_resp && product_performance_resp.data && product_performance_resp.data.result &&
        product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
          // this.loading.get_product = true

          performance_list.push(...product_performance_resp.data.result.items)
          if (performance_list.length > product_performance_resp.data.result.total) {
            break
          }

          for (const product of product_performance_resp.data.result.items) {
            const product_found = this.product_list.find(i => i.itemid === product.id)
            if (product_found) product_found.add_to_cart_units = product.add_to_cart_units
          }

          await this.sleep(1000)
          page++
          product_performance_resp = await seller.get_product_performance_v3(page, page_size, start_time, end_time, 'past30days')
        }
      } catch (e) {
      } finally {
        this.loading.get_product = false
      }
    },

    async m__back_to_list(reload) {
      this.current_component = 'list'

      if (reload) {
        await Promise.all([
          this.m__get_flash_sale_files()
        ])
      }

      this.show_dialog.get_session = true
    },

    async m__get_flash_sale_files() {
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale/official', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      const resp2 = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      const resp_auto = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      for (const item of [...resp.data, ...resp2.data]) {
        item.auto = resp_auto.data.find(i => i.flashSaleFileId === item.id)
      }
      this.flash_sale_files = [...resp.data, ...resp2.data]
    },

    async m__get_campaigns() {
      if (this.tab === '5') return

      this.campaign_list = []

      const form = {
        campaign_scene: ['CAMPAIGN_SCENE_FLASH_SALE'],
        pagination: {
          limit: 10,
          offset: 0,
          sort_type: 9
        },
        view_flag: +this.tab
      }
      let response = await this.seller.get_landing_page_campaign_list(form)
      while (response && response.data && response.data && response.data.list.length) {
        this.campaign_list.push(...response.data.list)

        form.pagination.offset += form.pagination.limit
        response = await this.seller.get_landing_page_campaign_list(form)
      }
    }
  }
}
</script>

<style lang="scss">
.shopee-tag__information.default {
  color: #ee4d2d;
  background-color: #fff1f0
}

.shopee-tag__information.warn {
  color: #eda500;
  background-color: #fff7e0
}

.shopee-tag__information.info {
  color: #40d0bd;
  background-color: #e8f9f7
}

.shopee-tag__information.success {
  color: #5c7;
  background-color: #eaf9ef
}

.shopee-tag__information.error {
  color: #ff4742;
  background-color: #ffe9e8
}

.shopee-tag__information.invalid {
  color: #666;
  background-color: #eee
}

.shopee-tag__information.return {
  color: #ff831d;
  background-color: #feece1
}

.shopee-tag__information {
  line-height: 18px;
  border-style: none;
  border-radius: 2px;
}

.shopee-tag {
  position: relative;
  display: inline-block;
  height: 18px;
  padding: 0 4px;
  font-size: 12px;
  font-weight: 500;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid transparent;
  border-right: 0;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/flash_sale_shopee/index.vue